import { Tag } from 'antd'

import { useLocales } from 'src/locales'

type Props = {
  status: boolean
}

enum QuestionnairesStatus {
  Success = 'success',
  Warning = 'warning'
}

export const PatientQuizState = ({ status }: Props) => {
  const { t } = useLocales()

  const color = status
    ? QuestionnairesStatus.Success
    : QuestionnairesStatus.Warning
  const text = status ? 'completed' : 'not_completed'

  return <Tag color={color}>{t(`questionnaires.${text}`)}</Tag>
}
